import * as React from "react";

import "./checkout-approval.scss";

import {apiArray}         from "@Common/logic/api-array";
import {cs}               from "@Common/react/chain-services";
import {consumeContext}   from "@Common/react/context";
import {Load2}            from "@Common/react/load2";
import {Static2}          from "@Common/react/static-2";
import {AlertModal}       from "@Common/ui-components/heavy/common/design2/dialogs/alert-modal/alert-modal";
import {InfoBlock}        from "@Common/ui-components/heavy/mailing-ui/create-mailing-list-modal/types/common/info-block/info-block";
import {ErrorHighlighter} from "@Common/ui-components/light/error-highlighter";
import {scrollIntoView}   from "@Common/ui-components/light/scroll-into-view";
import {values}           from "@Common/utils/objects";

import {ApprovalConflict}    from "./approval-conflict";
import {OciApproval}         from "./oci-approval";
import {ProcurementApproval} from "./procurement-approval";

export const CheckoutApproval = ({cart, disabled, store, next}) => cs(
    consumeContext("apis"),
    consumeContext("company"),
    consumeContext("cart"),
    consumeContext("routerHistory"),
    ["cartApproval", ({apis}, next) => Load2({
        _key: !disabled && JSON.stringify(apiArray(cart?.appliedPayments?.billing)?.map((b) => b.billingId)),
        fetch: () => disabled ? null : apis.next.cart.getCartApproval(cart.cartId),
        next,
    })],
    ["approvalConflict", (_, next) => ApprovalConflict({disabled, cart, store, next})],


    ["eh", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],

    ["oci", (_, next) => OciApproval({disabled, cart, next})],
    ["procurement", (_, next) => ProcurementApproval({disabled, cart, next})],
    ["alertModal", ({}, next) => AlertModal({next})],
    ({cartApproval, approvalConflict, eh, domRef, apis, oci, procurement, company, cart: rootCart, alertModal, routerHistory}) => {
        if (disabled) {
            return next();
        }
        const loading = (
            cartApproval.loading ||
            !cartApproval.value ||
            false
        );
        const requiredApproval = loading ? null : values(cartApproval.value.approvalDetails??{}).find((oa : any) => oa.approvalRequired);
        const error = approvalConflict.error ?? oci?.error;
        return next({
            loading,
            invalid: loading || error,
            active: requiredApproval,
            actionLabel: requiredApproval?.approvalName ?? "Submit for Approval",
            highlightErrors: () => {
                eh.start();
                scrollIntoView(domRef.get());
            },

            render: () => error && (
                InfoBlock({
                    type: "warning",
                    className: eh.css,
                    domRef: domRef.set,
                    content: (
                        <div className="checkout-approval-5ds info-block">
                            {error.message}.
                            {error.resolve && <>
                                {" "}
                                <a {...{
                                    onClick: error.resolve,
                                }}>
                                    Resolve?
                                </a>
                            </>}
                        </div>
                    ),
                })
            ),

            submit: async ({logger}) => {

                const result = await apis.next.cart.createApprovalRequest(cart.cartId);
                if (result.result === "failure") {
                    logger.logCheckoutSubmitForApprovalFailure({cartId: cart.cartId, result});
                    alertModal.show({
                        message: result.errors.msg,
                    });
                } else {
                    logger.logCheckoutSubmitForApprovalSuccess({cartId: cart.cartId, result});

                    if (oci) {
                        await oci.submitRequest();
                    } else if (procurement) {
                        await procurement.submitRequest();
                    } else {
                        await alertModal.show({
                            message: "Cart successfully sent for Approval",
                        });
                        rootCart.onChange(null);
                        routerHistory.push(`/account/orders/pending`);
                    }
                }
            },
        });
    },
);
